import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AppearanceFormGroup, ComponentPlacement, DeliveryCountdownTimerFormGroup, TimerFormat } from '../../models';
import { ShopService } from '@app/services/shops/shop.service';
import { BANNER_VARIANT_OPTIONS } from '@pages/checkout-app/checkout-layout/main/components/extensions/constants';

@Component({
  selector: 'delivery-countdown-timer-form-appearance',
  templateUrl: './delivery-countdown-timer-form-appearance.component.html',
  styleUrl: './delivery-countdown-timer-form-appearance.component.scss',
  standalone: false,
})
export class DeliveryCountdownTimerFormAppearanceComponent {
  @Input() formGroup: FormGroup<DeliveryCountdownTimerFormGroup>;

  ComponentPlacement = ComponentPlacement;
  TimerFormat = TimerFormat;

  readonly bannerVariantOptions = BANNER_VARIANT_OPTIONS;

  constructor(public shopService: ShopService) {}

  get appearanceGroup(): FormGroup<AppearanceFormGroup> {
    return this.formGroup.get('appearance') as FormGroup<AppearanceFormGroup>;
  }
}
